import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { NoveltyCheckSearchApi, NoveltyCheckSearchApiImpl } from './apis';
import {
    NoveltyExampleService,
    NoveltyExampleServiceImpl,
} from './services/novelty-example-service';

export const noveltyCheckSearchContainer = new ContainerModule((bind) => {
    bind(NoveltyCheckSearchApi).to(NoveltyCheckSearchApiImpl);
    bind(NoveltyExampleService).to(NoveltyExampleServiceImpl);
});
